<template>
  <div v-if="vm">
    <el-form-item label="申请人" required>
      <work-order-user-select-v2
        v-if="vm.allUserOptions.length"
        v-model="vm.sealApplicantUsers"
        :allOptions="vm.allUserOptions"
        :disabledNullBeisen="true"
        :multiple-limit="1"
        @input="vm.onSealApplicantChange"
      />
    </el-form-item>
    <el-form-item label="电子邮件" required>
      <el-input
        v-model="vm.sealArchive.email"
        readonly
        :disabled="true"
        placeholder="预填写根据申请人来"
      />
    </el-form-item>
    <el-form-item label="工作地点" required>
      <el-input
        v-model="vm.sealArchive.workLocation"
        readonly
        :disabled="true"
        placeholder="预填写根据申请人来"
      />
    </el-form-item>
    <el-form-item label="使用时间" required>
      <el-date-picker
        v-model="vm.sealUsageDateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item label="公司公章" required>
      <el-radio-group v-model="vm.sealNeedCompanySeal">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="vm.sealNeedCompanySeal" label-width="125px" required>
      <el-select
        v-model="vm.sealSealEntityId"
        placeholder="请选择主体"
        filterable
        style="width: 100%; margin-top: 4px"
      >
        <el-option
          v-for="ent in vm.companyEntityOptions"
          :key="vm.entityRowId(ent)"
          :label="ent.companyName"
          :value="vm.entityRowId(ent)"
        />
      </el-select>
    </el-form-item>
    <el-form-item v-if="vm.sealNeedCompanySeal" label-width="125px" required>
      <work-order-file-upload
        :list.sync="vm.sealStampAttachments"
        :upload-limit="9"
        :extra-file-types="vm.sealExtraFileTypes"
        @uploadLoading="vm.onSealUploadLoading"
      />
      <div style="color: #ff0000">
        请注意公司统一盖章时间：上午12点，下午5点
      </div>
    </el-form-item>
    <el-form-item label="公司资质" required>
      <el-radio-group v-model="vm.sealNeedQualification">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="vm.sealNeedQualification" label-width="125px" required>
      <el-select
        v-model="vm.sealQualificationEntityId"
        placeholder="请选择主体"
        filterable
        style="width: 100%; margin-top: 4px"
      >
        <el-option
          v-for="ent in vm.companyEntityOptions"
          :key="'q-' + vm.entityRowId(ent)"
          :label="ent.companyName"
          :value="vm.entityRowId(ent)"
        />
      </el-select>
    </el-form-item>
    <el-form-item v-if="vm.sealNeedQualification" label-width="125px" required>
      <el-select
        v-model="vm.sealQualificationType"
        placeholder="请选择资质名称"
        filterable
        style="width: 100%; margin-top: 4px"
      >
        <el-option
          v-for="name in vm.sealQualificationNameOptions"
          :key="name"
          :label="name"
          :value="name"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="vm.sealShowNeedLegalBlock"
      label="需要法人信息"
      required
    >
      <el-radio-group v-model="vm.sealNeedLegalPersonInfo">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
      <span
        v-if="vm.sealNeedLegalPersonInfo"
        style="padding-left: 10px; color: chocolate"
      >
        {{ vm.sealLegalPersonFlowText }}
      </span>
    </el-form-item>
    <el-form-item label="公章或资质外带" required>
      <el-radio-group v-model="vm.sealIsTakenOut">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="用途" required>
      <el-select
        v-model="vm.sealPurpose"
        placeholder="请选择"
        style="width: 100%"
      >
        <el-option
          v-for="p in vm.sealPurposeOptions"
          :key="p"
          :label="p"
          :value="p"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="具体使用说明" required>
      <el-input
        v-model="vm.sealUsageDescription"
        type="textarea"
        :autosize="{ minRows: 4 }"
        maxlength="500"
        show-word-limit
        placeholder="多行输入"
      />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "WorkSubmitFormSeal",
  inject: {
    workSubmit: {
      default: null,
    },
  },
  computed: {
    vm() {
      return this.workSubmit;
    },
  },
};
</script>
